import { googleMasApi } from '../api/googleMapsApi'

import {
  GoogleMapsPlace,
  GoogleMapsPrediction,
  HttpResponse
} from '../interfaces/googleMapsInterfaces'

export const getGoogleMapsPredictions = async (params: {
  input: string
  sessionToken: string
  types?: string[]
  includedRegionCodes?: string[]
  includedPrimaryTypes?: string[]
  languageCode?: string
  apiKey: string
}): Promise<HttpResponse<GoogleMapsPrediction[]>> => {
  const { apiKey, ...restParams } = params
  try {
    const response = await googleMasApi.post<any>(
      `/places:autocomplete?key=${apiKey}`,
      restParams
    )

    return {
      isSuccess: true,
      data: response?.suggestions
    }
  } catch (e) {
    return {
      isSuccess: false,
      error: {
        message: 'Error al obtener las predicciones',
        code: 'error_getting_predictions'
      }
    }
  }
}

export const getPlaceDetailsById = async (params: {
  placeId: string
  sessionToken: string
  apiKey: string
}): Promise<HttpResponse<GoogleMapsPlace>> => {
  try {
    const { placeId, sessionToken, apiKey } = params

    const response = await googleMasApi.get<any>(
      `/places/${placeId}?key=${apiKey}&sessionToken=${sessionToken}&fields=id,location,addressComponents,types`
    )

    return {
      isSuccess: true,
      data: response
    }
  } catch (e) {
    return {
      isSuccess: false,
      error: {
        message: 'Error al obtener los detalles del lugar',
        code: 'error_getting_place_details'
      }
    }
  }
}
